import PropTypes from "prop-types"
import styled from "styled-components"
import {
  LEARNING_ACTION_FILTER_COMPLETE_COURSE,
  LEARNING_ACTION_FILTER_COMPLETE_STEP,
  LEARNING_ACTION_FILTER_CREATE_DISCUSSION_CREATE_RESPONSE,
  LEARNING_ACTION_FILTER_CREATE_REGISTRATION,
  LEARNING_ACTION_FILTER_NONE
} from "../../../activity/constants"
import CommunityAreaFilter from "../CommunityAreaFilter"

const StyledCommunityAreaFilter = styled(CommunityAreaFilter)`
  grid-gap: 0px;
`

const getControlFilterLabel = (filter, translator) => {
  switch (filter) {
    case LEARNING_ACTION_FILTER_NONE:
      return {
        title: translator("All activity")
      }
    case LEARNING_ACTION_FILTER_COMPLETE_STEP:
      return {
        title: translator("Step completions")
      }
    case LEARNING_ACTION_FILTER_CREATE_DISCUSSION_CREATE_RESPONSE:
      return {
        title: translator("Discussions")
      }
    case LEARNING_ACTION_FILTER_CREATE_REGISTRATION:
      return {
        title: translator("Registrations")
      }
    case LEARNING_ACTION_FILTER_COMPLETE_COURSE:
      return {
        title: translator("Completions")
      }
  }
}

const FILTERS = [
  LEARNING_ACTION_FILTER_NONE,
  LEARNING_ACTION_FILTER_COMPLETE_STEP,
  LEARNING_ACTION_FILTER_COMPLETE_COURSE,
  LEARNING_ACTION_FILTER_CREATE_DISCUSSION_CREATE_RESPONSE,
  LEARNING_ACTION_FILTER_CREATE_REGISTRATION
]

// controlled component
const CommunityDiscussionFilter = ({
  inverted,
  children,
  filter,
  onFilter
}) => {
  return (
    <StyledCommunityAreaFilter
      filter={filter}
      filters={FILTERS}
      onFilter={onFilter}
      getControlFilterLabel={getControlFilterLabel}
      inverted={inverted}
    >
      {children}
    </StyledCommunityAreaFilter>
  )
}

CommunityDiscussionFilter.displayName = "CommunityDiscussionFilter"

CommunityDiscussionFilter.propTypes = {
  inverted: PropTypes.bool
}

export default CommunityDiscussionFilter
